<template>
  <div id="app">
    <div class="data-survey" v-show='!showSkipped'>
      <transition name="show-from-left">
          <Popover name="helpdata" :width="240">
              <Help :titleChart="'Data Survey'">
                <div slot="content">
                  <p> {{ $t("156") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts title-bt-help">{{ $t("157") }}
        <button class="bt-help" v-popover:helpdata.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <highcharts :options="chartOptions" ref='chart'></highcharts>
    </div>

    <transition name="fade">
      <chartsSkipped v-show='showSkipped'></chartsSkipped>
    </transition>

    <div id='buttons-change' class="btn-group btn-group-sm" role="group" aria-label="Buttons">
      <button type="button" class="btn btn-secondary" @click="getBatteryChart()"><small>{{ btn_title }}</small></button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations } from 'vuex'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

import ChartsSkipped from 'src/components/Dashboard/Views/Charts/ChartsSkipped'

export default {
  name: 'report-chart',
  components: {
    ChartsSkipped,
    Help
  },
  props: {
      title: {
          type: String
      },
      gridtxt: {
          type: String
      },
      data: {
          type: Array
      },
      help: {
          type: String
      },
      filters: {
          type: Object
      }
  },
  data () {
    return {
      showSkipped: false,
      activeBattery: false,
      btn_title: this.$t("155"),
      tableData: [],
      chartOptions: {
        //colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8'],
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0, 
            size: '70%',
            dataLabels: {
              distance: 1
            },
            cursor: 'pointer',
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color: #fff">{point.name}:<br> </span><span style="color: #fff">{point.percentage:.1f}%<span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events:{
              click: this.loadGrid
            },
            states: {
                hover: {
                enabled: true,
                }
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px',
              fontWeight: 'normal'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        series: [
            {
                name: "",
                colorByPoint: true,
                data: []
            }
        ],
        exporting: { 
            enabled: false
        },
        credits: {
            enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
                marginTop: '20px'
            }
        },
      },
    }
  },
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){
      let status = event.point.drilldown;
      let point_name = event.point.name
      let NAME_CHART = `${this.title} - ${point_name.toUpperCase()}`;
      const ENDPOINT = `v1/mysemeq-ambev/get-general-report?year=${this.filters.year}&period=${this.filters.period}&plant=${this.filters.plant}&region=${this.filters.region}&status=${status}&technique=${this.filters.technique}&skipped=&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}`

      let grid = {
        totalDados: event.point.y,
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
              "rows": '',
              "plant": this.$t("310"),
              "area": this.$t("311"),
              "sector": this.$t("312"),
              "component": this.$t("313"),
              "component_tag": this.$t("314"),
              "component_type_en": this.$t("315"),
              "machine": this.$t("316"),
              "machine_tag": this.$t("317"),
              "status_txt_en": this.$t("318"),
              "report_number": this.$t("319"), 
              "approved_datetime": this.$t("320"),
              "technique_en": this.$t("321"),
              "ref_date": this.$t("322"),
              "link": this.$t("323"),
              "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid -' + this.title,
        txtHelp: this.gridtxt
      }

      if (this.filters.plant) {
        grid.title += ' - ' + this.filters.plant_name
        delete grid.columns['plant']
      } else if (this.filters.region){
        grid.title += ' - ' + this.filters.region
      }

      this.changeGrid(grid);
    },

    setChartData () {
      let res = this.data;
      let values = [];
      let color = '';
      for (let key in res) {
        color = '';
        if (res[key].status == 4 || res[key].status == 2 || res[key].status == 0){
          color = '#e4d354';
        }

        else if (res[key].status == -1 || res[key].status == 1){
          color = '#f45b5b';
        }

        else if (res[key].status == 5 || res[key].status == 3 || res[key].status == 6){
          color = '#90ed7d';
        }

        values.push({'name': res[key].status_txt, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }

      this.chartOptions.series[0].data = values;
    },
    getBatteryChart () {
      this.showSkipped = !this.showSkipped;
      this.activeBattery = !this.activeBattery;
      this.btn_title = this.showSkipped ? this.$t("157") : this.$t("155")
    }
  },
  watch: {
    data: function(){
      this.setChartData();
    }
  }
}
</script>

<style scoped>
tspan {
  stroke: none!important;
  stroke-width: 1px;
  stroke-linejoin: round;
}

.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

div[data-popover="helpdata"] {
  left: 69% !important;
  top: 0% !important;
} 

div[data-popover="help"] {
  left: 69% !important;
}

.fade-enter-active {
  transition: opacity .8s;
}

.fade-leave-active {
  display: none;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/DataSurveyChart.vue